import AIContent from '@/features/ai-chat/components/AskGXDrawer/Messages/AIMessage/AIContent/AIContent';
import MessageFooter from '@/features/ai-chat/components/AskGXDrawer/Messages/MessageFooter/MessageFooter';
import { useRateAnswer } from '@/features/ai-chat/components/AskGXDrawer/Messages/RateAnswer/useRateAnswer';
import SymbolsPreviewSection from '@/features/ai-chat/components/AskGXDrawer/Messages/SymbolsPreviewSection/SymbolsPreviewSection';
import { useChatState } from '@/features/ai-chat/state/useChat';

import type { UIMessage } from '@tanstack/ai-client';
import { Bot } from 'lucide-react';

const AIMessage = ({
  msg,
  isSending,
  isLastMessage,
  prompt,
  version
}: {
  msg: UIMessage;
  isSending: boolean;
  isLastMessage: boolean;
  prompt: string;
  version: number;
}) => {
  const { handleRate, conversationId } = useRateAnswer();
  const { ratings } = useChatState();

  return (
    <div className='min-w-full max-w-full'>
      <div className='mb-3 flex items-center gap-2.5'>
        <span className='flex size-7 items-center justify-center rounded-lg border border-gx-highlight/40 bg-gx-highlight/10 text-gx-highlight'>
          <Bot
            aria-hidden='true'
            className='size-3.5'
          />
        </span>
        <span className='text-sm font-semibold text-gx-text'>GX Go Assistant</span>
      </div>
      <div className='wrap-break-word hyphens-auto pl-9 text-sm leading-6 text-gx-text'>
        <AIContent msg={msg} />
        <SymbolsPreviewSection
          isVisible={!isSending || !isLastMessage}
          msg={msg}
        />
        <MessageFooter
          conversationId={conversationId}
          isLastMessage={isLastMessage}
          isSending={isSending}
          msg={msg}
          prompt={prompt}
          rating={ratings[msg.id] ?? 0}
          version={version}
          onRate={handleRate}
        />
      </div>
    </div>
  );
};

export default AIMessage;
